module.exports = __webpack_public_path__ + "static/diritto-fallimentare-017e8526140ac7d662bdd7d3feb3f05d.png";